import LoadableImage from "common/components/ui/LoadableImage";
import type { VolunteerExperience } from "common/types";

import { formatMonthAndYear, formatRange } from "../../utils";
import SectionContainer from "./SectionContainer";
import SectionItem from "./SectionItem";

import CompanyFallbackImage from "assets/images/profile-placeholders/company.png";

export default function Volunteering({
  volunteering,
}: {
  volunteering: VolunteerExperience[];
}) {
  return (
    <SectionContainer title="Volunteering">
      {volunteering.map(
        ({ start_date, end_date, company, role_name }, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: no unique key
          <SectionItem key={index}>
            <div className="flex items-start gap-x-2">
              <LoadableImage
                className="rounded-2xl size-10"
                src={company.logo_url}
                fallbackImage={CompanyFallbackImage}
              />
              <div className="flex flex-col gap-y-0.5">
                <span className="break-all text-sm-bold">{role_name}</span>
                <span className="break-all text-xs-medium text-black-500">
                  {company.name}
                </span>
              </div>
              {(start_date || end_date) && (
                <span className="ml-auto text-nowrap text-button-xxs text-black-500">
                  {formatRange(
                    start_date && formatMonthAndYear(start_date),
                    end_date ? formatMonthAndYear(end_date) : "Present",
                  )}
                </span>
              )}
            </div>
          </SectionItem>
        ),
      )}
    </SectionContainer>
  );
}
